import { CanceledError } from "axios";
import { apiClient, type ApiRequestConfig } from "./api";
import { getPrivateQueryGeneration } from "./queryPrivacy";
import { getStoredActiveTenantId } from "./tenantStorage";

/** Guard both sides of CSRF/auth awaits, and discard responses from an abandoned business/account. */
export function stringingApi(tenantId: number, accountId: number) {
  return async function request<T>(
    path: string,
    method = "GET",
    data?: unknown,
    signal?: AbortSignal,
  ): Promise<T> {
    const generation = getPrivateQueryGeneration();
    const assertRequestCurrent = () => {
      if (
        generation !== getPrivateQueryGeneration() ||
        getStoredActiveTenantId() !== tenantId
      ) {
        throw new CanceledError("Workspace changed");
      }
    };
    assertRequestCurrent();
    const config: ApiRequestConfig = {
      url: `/api/v1/web/stringing${path}`,
      method,
      data,
      signal,
      headers: { "X-TARK-Expected-User-Id": String(accountId) },
      assertRequestCurrent,
      recoverAccountChange: true,
    };
    const response = await apiClient.request<T>(config);
    assertRequestCurrent();
    return response.data;
  };
}
